export const REVERIFICATION_ROOT_ROUTE = 'account/reverification'
